import React from "react";
import "./ServicesNav.css";

const ServicesNav = ({ onServiceClick, selectedService }) => {
  return (
    <nav className="services-nav">
      <button onClick={() => onServiceClick("crop")}>Crop Production</button>
      <button onClick={() => onServiceClick("animal")}>Animal and Fish Farming</button>
      <button onClick={() => onServiceClick("clothes")}>Clothe Production</button>
      <button onClick={() => onServiceClick("shoe")}>Shoe Production</button>
      <button onClick={() => onServiceClick("furniture")}>Furniture Production</button>
      <button onClick={() => onServiceClick("baking")}>Baking Bread Products</button>
      <button onClick={() => onServiceClick("water")}>Table Water Production</button>
    </nav>
  );
};

export default ServicesNav;
